import type { PaymentEventBase, PaymentEventProperties } from '../types/payment';

// The spec marks member_id and transaction_id as "if known" — omit rather than send null, so
// downstream queries can distinguish "not applicable" from "we tried and got nothing".
export const paymentEventProperties = ({
  purchaseType,
  memberId,
  transactionId,
}: PaymentEventBase): PaymentEventProperties => ({
  ...(purchaseType && { purchase_type: purchaseType }),
  ...(memberId && { member_id: memberId }),
  ...(transactionId && { transaction_id: transactionId }),
});
